import { memo } from "react";
import { Flex } from "../../../flex";
import { Text } from "../../../text";
import * as legendCss from "../line-and-bar-chart/legend.module.css";
import { RedoBarChartLegendPosition } from "./types";

export const BarChartLegendItem = memo(function BarChartLegendItem({
  name,
  color,
  isVisible,
  onClick,
}: {
  name: string;
  color: string;
  isVisible: boolean;
  onClick?: () => void;
}) {
  return (
    <Flex
      align="center"
      cursor={onClick ? "pointer" : "default"}
      gap="xs"
      onClick={onClick}
      style={{ opacity: isVisible ? 1 : 0.4 }}
    >
      <div
        className={legendCss.legendIndicator}
        style={{ backgroundColor: color }}
      />
      <Text fontSize="sm" textColor="tertiary" title={name}>
        {name}
      </Text>
    </Flex>
  );
});

export interface BarChartLegendSeries {
  name: string;
  color: string;
}

export const BarChartLegend = memo(function BarChartLegend({
  series,
  position,
  visibleDatasets,
  onItemClick,
}: {
  series: BarChartLegendSeries[];
  position: RedoBarChartLegendPosition;
  visibleDatasets: Set<number>;
  onItemClick: (index: number) => void;
}) {
  if (!position || !series.length) {
    return null;
  }

  return (
    <Flex
      className={position === "right" ? legendCss.legendRight : ""}
      flexDirection={
        position === "top" || position === "bottom" ? "row" : "column"
      }
      gap="md"
      justify={position === "bottom" ? "center" : "flex-start"}
      wrap={position === "top" || position === "bottom" ? "wrap" : "nowrap"}
    >
      {series.map((item, index) => (
        <BarChartLegendItem
          color={item.color}
          isVisible={visibleDatasets.has(index)}
          key={index}
          name={item.name}
          onClick={() => onItemClick(index)}
        />
      ))}
    </Flex>
  );
});
